import React, { useState } from 'react' // eslint-disable-line
import styled from 'styled-components'
import { Link } from '@sentecacommerce-theme/lib'
import Logo from '../../../../public/svg/LogoHippoland'
import { IconBasket, IconMenu } from '../../../Common'
import IconFavorites from '../../../../public/svg/heart-bold'
import { SuggestedMenu } from '../../navbar.props'

import { Search } from '../Search'
import {
  useBasketTotalCount,
  useWishlistTotalCount,
} from '@sentecacommerce-theme/lib'

export const MobileNavRow = ({
  value,
  searchBarData,
  setValue,
  handleSearchBox,
  drawerToggleHandler,
  suggestedMenus,
}: {
  drawerToggleHandler: () => void
  suggestedMenus: SuggestedMenu[]
  value: string
  searchBarData: any
  setValue: React.Dispatch<React.SetStateAction<string>>
  handleSearchBox: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const itemsInBasketCount = useBasketTotalCount()

  const wishlistItemsCount = useWishlistTotalCount()

  return (
    <Container>
      <Left>
        <Link href="/" passHref>
          <LogoContainer aria-label="Logo">
            <Logo />
          </LogoContainer>
        </Link>
      </Left>
      <Right>
        <IconWrapper relative>
          <Link href="/favorites" passHref>
            <a aria-label="Favorites">
              {wishlistItemsCount ? (
                <Count>
                  <span>{wishlistItemsCount}</span>
                </Count>
              ) : null}
              <IconFavorites
                style={{ height: '2.4rem', width: '2.4rem' }}
                fill="currentColor"
              />
            </a>
          </Link>
        </IconWrapper>
        <IconWrapper relative>
          <Link href="/basket" passHref>
            <a aria-label="Basket">
              {itemsInBasketCount ? (
                <Count>
                  <span>{itemsInBasketCount}</span>
                </Count>
              ) : null}
              <IconBasket width="26" height="26" fill="currentColor" />
            </a>
          </Link>
        </IconWrapper>
        <IconWrapper relative>
          <StyledMenuIcon onClick={drawerToggleHandler} />
        </IconWrapper>
      </Right>
      <Bottom>
        <Search
          searchData={searchBarData}
          value={value}
          setValue={setValue}
          handleSearchBox={handleSearchBox}
          suggestedMenus={suggestedMenus}
        />
      </Bottom>
    </Container>
  )
}

const Count = styled.span.attrs({
  className: 'd-block',
})`
  & > span {
    position: absolute;
    font-size: 1.1rem;
    font-weight: bold;
    right: -1rem;
    top: -0.8rem;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.burntSienna};
    color: ${({ theme }) => theme.palette.secondary};
    text-align: center;
  }
`

const Container = styled.div.attrs({
  className:
    'pt-1 pb-2 d-md-none d-flex flex-wrap justify-content-between align-items-center',
})`
  width: 100%;
  background: ${({ theme }) => theme.palette.secondary};
  margin-top: 0.4rem;
`

const Left = styled.div.attrs({
  className: 'pr-4 d-flex align-items-center',
})`
  height: 4rem;
  width: 50%;
`

const Right = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-end',
})`
  width: 50%;
  height: 4rem;
`

const Bottom = styled.div.attrs({
  className: 'mt-4',
})`
  height: 4.2rem;
  width: 100%;
`

const IconWrapper = styled.span<{ relative?: boolean }>`
  margin-left: 1.8rem;
  position: relative;

  color: ${({ theme }) => theme.palette.silverTree};

  & svg {
    width: 2.4rem;
    height: 2.4rem;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.burntSienna};
  }
`

const LogoContainer = styled.a`
  outline: 0;
  line-height: 0;
  width: 8.6rem;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary};
`
const StyledMenuIcon = styled(IconMenu)`
  fill: ${({ theme }) => theme.palette.silverTree};
`
